import _includes from "lodash/includes";
import { Component, Vue } from "vue-property-decorator";

@Component
class UpdateClassSidebar extends Vue {
  public changeClassPage(classPage: any[]) {
    const changeClass = classPage;
    const sidebarClasses = [
      "Admin",
      "Customer",
      "Products",
      "AdminCustomer",
      "Order",
      "Setting",
    ];

    changeClass.map((className, index) => {
      if (_includes(sidebarClasses, className)) {
        changeClass.splice(index, 1);
      }
    });

    // changeClass.push(this.$router.currentRoute.meta.className);

    return changeClass;
  }
}
export default UpdateClassSidebar;
